import { accountUpdateApi } from "../../api/account/accountUpdateApi"

type PayloadShape = Parameters<typeof accountUpdateApi>[0]

export async function accountUpdateService(payload: PayloadShape, token: string) {
	return await accountUpdateApi(payload, token)
}
